import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
interface ResultLockedProps {
  onOpen: () => void;
}
export function ResultLocked({
  onOpen
}: ResultLockedProps) {
  return <div className="bg-violeta px-6 py-12 text-hueso sm:px-10 sm:py-14" data-id="element-138" data-mp="3rzwerur2g0n4">
      <LockIcon className="h-6 w-6 text-dorado" aria-hidden="true" data-id="element-139" data-mp="3rxtiwu38fdah" />

      <h2 className="mt-5 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-140" data-mp="uen77ceg3hm">
        Tu resultado está listo, pero todavía no puedo mostrártelo
      </h2>

      <p className="mt-5 max-w-xl font-sans text-base leading-relaxed text-hueso/80" data-id="element-141" data-mp="skswsrddqtnh">
        Escribe tu nombre, correo y WhatsApp y te envío tu nivel de consciencia completo, con la
        explicación de por qué te cuesta soltar y el primer paso concreto para pasar de página.
      </p>

      <button type="button" onClick={onOpen} className="mt-8 inline-flex items-center gap-2 rounded-sm bg-dorado px-8 py-4 font-sans text-base font-semibold text-noche transition-colors duration-150 ease-out hover:bg-dorado-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-hueso focus-visible:ring-offset-2 focus-visible:ring-offset-violeta" data-id="element-142" data-mp="jlxkqynnmpc9">
        <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="ntl37sntnyoh" />
        Ver mi resultado
      </button>
    </div>;
}